(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8327],{

/***/ 6230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FormNewsletter/index.js
var FormNewsletter = __webpack_require__(32314);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/WhatPartnerLove/index.js
var WhatPartnerLove = __webpack_require__(68696);
// EXTERNAL MODULE: ./components/templates/offshore/become-our-partner/MembershipTier.js
var MembershipTier = __webpack_require__(22637);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/become-our-partner/index.js










var Component = function Component(_ref) {
  var _data$banner, _data$banner2, _data$advantage, _data$advantage2, _data$advantage3, _data$advantage4;

  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        minHeightBanner: "banner-min-h-569",
        title: "Partner with<br/> BBCIncorp",
        description: data === null || data === void 0 ? void 0 : (_data$banner = data.banner) === null || _data$banner === void 0 ? void 0 : _data$banner.description,
        titleProps: {
          textColor: "banner-title-default-color bg-bbc-gradient-liner1",
          className: "banner-default-title capitalize lg:tracking-[0.25px]"
        },
        bgColor: "bg-bbc-useful-links",
        breadcrumbs: data === null || data === void 0 ? void 0 : (_data$banner2 = data.banner) === null || _data$banner2 === void 0 ? void 0 : _data$banner2.breadcrumbs,
        leftClassName: "lg:col-7",
        rightClassName: "lg:col-5",
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          className: "max-w-full object-cover object-center",
          src: "/assets/images/common/become-our-partner/banner-partner.png",
          width: 622,
          height: 436,
          alt: "banner",
          priority: true,
          wrapper: {
            className: "bbc-banner-image-bottom-0"
          }
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(WhatPartnerLove/* default */.Z, {
        title: data === null || data === void 0 ? void 0 : (_data$advantage = data.advantage) === null || _data$advantage === void 0 ? void 0 : _data$advantage.title,
        subTitle: data === null || data === void 0 ? void 0 : (_data$advantage2 = data.advantage) === null || _data$advantage2 === void 0 ? void 0 : _data$advantage2.subTitle,
        image: data === null || data === void 0 ? void 0 : (_data$advantage3 = data.advantage) === null || _data$advantage3 === void 0 ? void 0 : _data$advantage3.image,
        data: data === null || data === void 0 ? void 0 : (_data$advantage4 = data.advantage) === null || _data$advantage4 === void 0 ? void 0 : _data$advantage4.data
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "The one partner that moves the needle",
          className: "title-h2 mb-6 text-center text-bbc-brand-800 lg:mb-10"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row gap-y-6",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 flex flex-col lg:col-6",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mb-6 lg:order-2 lg:mb-0 lg:mt-10",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h4",
                text: "A centralized platform to streamline your management effort",
                className: "mb-4 text-lg font-medium text-bbc-brand-700 lg:mb-6 lg:min-h-[72px] lg:text-2xl lg:font-semibold lg:leading-9"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "Too busy to handle all legal stuff for your clients\u2019 companies? Our management portal was designed for just that. Set it up and keep them all compliant in one place."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/common/become-our-partner/section_2_1-partner.png",
              alt: "management portal",
              width: 540,
              height: 304
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 flex flex-col lg:col-6",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mb-6 lg:order-2 lg:mb-0 lg:mt-10",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h4",
                text: "Supporting marketing materials",
                className: "mb-4 text-lg font-medium text-bbc-brand-700 lg:mb-6 lg:min-h-[72px] lg:text-2xl lg:font-semibold lg:leading-9"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "Take advantage of our country profiles and service brochures to outreach new clients. Make them feel more confident to enlist your services."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/offshore/become-our-partner/section_2_2-offshore-partner.png",
              alt: "partner program brochure",
              width: 2160,
              height: 1216
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "relative py-10 px-[15px] lg:py-20",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container relative z-10 text-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "How To Become Our Partner",
          className: "title-h2 mb-6 text-white lg:mb-10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-lg font-medium text-white",
          children: "If you intend to use our incorporation service for more than 5 companies, then you are welcomed to join our programme."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/common/required-documents.png",
        width: 1920,
        height: 737,
        className: "h-full w-full",
        wrapper: {
          className: "absolute top-0 left-0 w-full h-full z-0"
        },
        alt: "section bg"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row justify-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 lg:col-8",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
              text: "Enjoy Great Benefit With Different Membership Tiers",
              className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:text-4xl lg:leading-[50px] lg:text-bbc-brand-700"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mb-6 text-center",
              children: "We offer multi-tiered discounts for clients with these milestones"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(MembershipTier/* default */.Z, {
            data: data
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormNewsletter/* default */.Z, {
          title: "Want To Find Out More About Our Partner Programme",
          description: "Just leave us your email, and we will respond with more details",
          bgColor: "bg-bbc-gradient-14",
          apiLink: "api/portal/contact_form/partner",
          triggerName: "Partner form",
          buttonText: "Submit"
        })
      })
    })]
  });
};

/* harmony default export */ var become_our_partner = (Component);
Component.defaultProps = {
  data: {}
};
;// CONCATENATED MODULE: ./pages/offshore/become-our-partner/data.json
var data_namespaceObject = JSON.parse('{"banner":{"breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Become Our Partner"}],"description":"Drive better clients\' experiences with our Partner Program - unlock more business opportunities and solve clients\' toughest challenges, all while cutting operational costs."},"membershipTiers":[{"title":"Bronze tier","color":"linear-gradient(128.88deg, #C85400 9.81%, #F8D352 118.57%)","image":"/assets/images/common/become-our-partner/bronze-partner.png","price":"25","contentList":[{"icon":"/assets/images/common/become-our-partner/check-partner.png","class":"font-medium","text":"5 active companies"},{"icon":"/assets/images/common/become-our-partner/mark-partner.png","text":"US$25 off per each from the 6th company you register *"}]},{"title":"Silver tier","color":"linear-gradient(128.88deg, #C4C4C4 9.81%, #E9E3CE 118.57%)","image":"/assets/images/common/become-our-partner/silver-partner.png","price":"50","contentList":[{"icon":"/assets/images/common/become-our-partner/check-partner.png","class":"font-medium","text":"10 active companies"},{"icon":"/assets/images/common/become-our-partner/mark-partner.png","text":"US$50 off per each from the 11th company you register *"}]},{"title":"Golden tier","color":"linear-gradient(128.88deg, #FDA700 9.81%, #FDD33F 118.57%)","image":"/assets/images/common/become-our-partner/golden-partner.png","price":"75","contentList":[{"icon":"/assets/images/common/become-our-partner/check-partner.png","class":"font-medium","text":"15 active companies"},{"icon":"/assets/images/common/become-our-partner/mark-partner.png","text":"US$75 off per each from the 16th company you register *"}]},{"title":"Platinum tier","color":"linear-gradient(128.88deg, #5CC7FF 9.81%, #B8D0FF 118.57%)","image":"/assets/images/common/become-our-partner/platinum-partner.png","price":"100","contentList":[{"icon":"/assets/images/common/become-our-partner/check-partner.png","class":"font-medium","text":"20 active companies"},{"icon":"/assets/images/common/become-our-partner/mark-partner.png","text":"US$100 off per each from the 21st company you register *"}]}],"advantage":{"title":"What Partners","subTitle":"Love About Our Programme","image":{"src":"/assets/images/offshore/become-our-partner/laptop-offshore-partner.png","altText":"What Partners Love About Our Programme"},"data":[{"id":1,"name":"Fast And Reliable Service","value":"Fast And Reliable Service"},{"id":2,"name":"Big Saving For Company Referral","value":"Big Saving For Company Referral"},{"id":3,"name":"Dedicated Customer Support","value":"Dedicated Customer Support"},{"id":4,"name":"Flexible Payment Method","value":"Flexible Payment Method"},{"id":5,"name":"Incorporation Without Notarizing Document","value":"Incorporation Without Notarizing Document"}]}}');
;// CONCATENATED MODULE: ./pages/offshore/become-our-partner/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    page: data === null || data === void 0 ? void 0 : data.page,
    locationRouter: "offshore",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(become_our_partner, {
      data: data_namespaceObject
    })
  });
}

/***/ }),

/***/ 56819:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/become-our-partner",
      function () {
        return __webpack_require__(6230);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,9593,9885,4090,9738,7447,2314,6987,9774,2888,179], function() { return __webpack_exec__(56819); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);